import LoginForm from './LoginForm'

export default LoginForm



// WEBPACK FOOTER //
// ./src/views/Login/components/LoginForm/index.js